import { SVGProps, Ref, forwardRef } from 'react';

export const SquareCircleFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 1c9.625 0 11 1.375 11 11s-1.375 11-11 11S1 21.625 1 12 2.375 1 12 1m0 5c-4.5 0-6 3-6 6s1.5 6 6 6 6-3 6-6-1.5-6-6-6"
            fill="currentColor"
        />
    </svg>
));
SquareCircleFilledSize24Glyph.displayName = 'SquareCircleFilledSize24Glyph';
